/* eslint-disable */
import React from 'react';
import getConfig from 'next/config';
import styled from 'styled-components';

import withI18n from '../../../utils/withI18n';
import { getLabel } from '../../../utils/i18n';
import FlexBox from '../../FlexBox';

const {
  publicRuntimeConfig: {
    assetPrefix,
  },
} = getConfig();

const WrapperBox = styled(FlexBox)`
  width: 100%;
  height: auto;
`;

const Content = styled(FlexBox)`
  width: 100%;
  height: 100%;
  margin: 0 auto;
  text-align: center;
  font-family: ${({ theme }) => theme.fontIBMBold};
  position: relative;
  align-content: start;
`;
const Row = styled(FlexBox)`
  align-content: start;
  > .table-cell {
    height: auto;
    overflow: hidden;
    width: 1260px;
    margin: 0 auto;
  }
  &.static {
    width: 100%;
    padding-top: 190px;
  @media screen and (max-width: 768px) {
    padding-top: 110px;
  }
    background: url(${assetPrefix + require('./imgs/hero.jpg')}) center center;
    background-size: cover;
    height:600px;
  }
`;
const Title = styled.div`
  color: ${({ theme }) => theme.dropdownBg};
  font-size: 28px;
  line-height:40px;
  font-style: normal;
  font-weight: bold;
  margin-bottom: ${({ theme }) => theme.fontSizeXxl};
`;
const Description = styled.h1`
  max-width:1200px;
  color: ${({ theme }) => theme.dropdownBg} !important;
  font-size: 76px;
  @media screen and (max-width: 768px) {
  font-size: 60px;
  }
  line-height:85px;
  font-style: normal;
  font-weight: bold;
  letter-spacing: 0.64px;
  font-family: ${({ theme }) => theme.fontIBMBold};
`;


type Props = {
  i18n: Object,
};

export default
@withI18n
class Banner extends React.Component<Props> {
  static defaultProps = {
    i18n: {},
  };

  render() {
    const { i18n } = this.props;
    return (
      <WrapperBox direction="column">
        <Content>
          <Row align="center" justify="center" className="static">
            <div className="table-cell">
              <Title>{getLabel('usExchange-aboutBanner-aboutUs', i18n, 'About Us')}</Title>
              <Description>{getLabel(`usExchange-aboutBanner-your`, i18n, 'We are your crypto gateway to the world.')}</Description>
            </div>
          </Row>
        </Content>
      </WrapperBox>
    );
  }
}
